export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Cinematic Background */}
      <div className="absolute inset-0">
        <img
          src="/images/aventador/IMG_9966.JPG"
          alt="Lamborghini Aventador - Carbon Fiber Build"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/50"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-28 md:py-32 relative z-10 w-full pt-32 md:pt-32">
        <div className="max-w-4xl">
          {/* Editorial Headline */}
          <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-[5.5rem] font-bold leading-[1.05] md:leading-[0.95] tracking-[-0.03em] md:tracking-[-0.04em] mb-5 md:mb-6">
            Precision-Engineered<br />
            Carbon Fiber<br />
            <span className="text-gray-400">For Your Machine</span>
          </h1>

          {/* Powerful Subline */}
          <p className="text-gray-300 text-base md:text-xl font-light leading-relaxed max-w-2xl mb-8 md:mb-12">
            Precizno izrađeni carbon fiber delovi za Lamborghini Aventador, Porsche, Mercedes G-Klasa, Renault Mégane i Fiat Abarth.
            Autoclave-cured perfekcija sa garantovanim OEM fitmentom.
          </p>

          {/* Sharp CTAs */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-5 mb-10 md:mb-16">
            <button className="bg-white px-8 py-4 text-black text-sm md:text-base font-semibold tracking-wide hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer text-center">
              EXPLORE COLLECTION
            </button>
            <button className="border border-white/40 px-8 py-4 text-white text-sm md:text-base font-semibold tracking-wide hover:bg-white/10 hover:border-white transition-all whitespace-nowrap cursor-pointer text-center">
              CUSTOM BUILDS
            </button>
          </div>

          {/* Trust Bar */}
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap items-center gap-4 sm:gap-8 pt-6 md:pt-8 border-t border-white/20">
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                <i className="ri-temp-cold-line text-white text-lg md:text-xl"></i>
              </div>
              <span className="text-gray-300 text-xs md:text-sm font-medium">Autoclave Cured</span>
            </div>

            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-white text-lg md:text-xl"></i>
              </div>
              <span className="text-gray-300 text-xs md:text-sm font-medium">OEM Fitment Guaranteed</span>
            </div>

            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                <i className="ri-global-line text-white text-lg md:text-xl"></i>
              </div>
              <span className="text-gray-300 text-xs md:text-sm font-medium">Worldwide Shipping</span>
            </div>

            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-lg md:text-xl"></i>
              </div>
              <span className="text-gray-300 text-xs md:text-sm font-medium">5-Year Warranty</span>
            </div>
          </div>
        </div>

        {/* Scroll Indicator - hidden on mobile */}
        <div className="hidden md:flex absolute bottom-12 left-8 items-center gap-3">
          <div className="w-[1px] h-16 bg-gradient-to-b from-white/60 to-transparent animate-pulse"></div>
          <div className="text-gray-400 text-xs uppercase tracking-[2px] font-medium -rotate-90 origin-left">Scroll</div>
        </div>
      </div>
    </section>
  );
}
